
import { useState } from 'react';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [language, setLanguage] = useState('pt');

  // Use functional update to avoid stale state closure
  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'pt' ? 'en' : 'pt'));
  };

  return (
    <div className="min-h-screen bg-zinc-900 text-white">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-black/80 backdrop-blur-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img
                src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/bfd7de7a21752a70fa4943d2e540af92.png"
                alt="VuVu Logo"
                className="w-8 h-8 mr-3 filter brightness-0 invert"
              />
              <div
                className="text-2xl font-bold tracking-wider"
                style={{ fontFamily: "Exo 2, sans-serif" }}
              >
                VuVu
              </div>
            </div>
            <div className="hidden md:flex space-x-8 items-center">
              <a href="#home" className="hover:text-amber-400 transition-colors cursor-pointer">
                {language === 'pt' ? 'Início' : 'Home'}
              </a>
              <a href="#about" className="hover:text-amber-400 transition-colors cursor-pointer">
                {language === 'pt' ? 'Sobre' : 'About'}
              </a>
              <a href="#menu" className="hover:text-amber-400 transition-colors cursor-pointer">
                Menu
              </a>
              <a href="#events" className="hover:text-amber-400 transition-colors cursor-pointer">
                {language === 'pt' ? 'Eventos' : 'Events'}
              </a>
              <a href="#contact" className="hover:text-amber-400 transition-colors cursor-pointer">
                {language === 'pt' ? 'Contato' : 'Contact'}
              </a>
              <div className="ml-4 flex items-center space-x-2">
                <button
                  onClick={() => setLanguage('pt')}
                  className={`w-8 h-6 flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer rounded-sm ${
                    language === 'pt' ? 'ring-2 ring-amber-400' : 'opacity-60'
                  }`}
                  title="Português"
                >
                  <img
                    src="https://public.readdy.ai/ai/img_res/54036d0c0ab8bba64ef79f9ae0dcb4d2.jpg"
                    alt="Português"
                    className="w-6 h-4 object-cover rounded-sm"
                  />
                </button>
                <button
                  onClick={() => setLanguage('en')}
                  className={`w-8 h-6 flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer rounded-sm ${
                    language === 'en' ? 'ring-2 ring-amber-400' : 'opacity-60'
                  }`}
                  title="English"
                >
                  <img
                    src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/248df571686c0c8746cad1fda1508cf8.jpeg"
                    alt="English"
                    className="w-6 h-4 object-cover rounded-sm"
                  />
                </button>
              </div>
            </div>
            <div className="md:hidden flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setLanguage('pt')}
                  className={`w-8 h-6 flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer rounded-sm ${
                    language === 'pt' ? 'ring-2 ring-amber-400' : 'opacity-60'
                  }`}
                  title="Português"
                >
                  <img
                    src="https://readdy.ai/api/search-image?query=Brazil%20flag%20clean%20design%20no%20white%20border%20transparent%20background%20minimal%20design%20high%20quality%20flag%20icon%20green%20yellow%20blue&width=24&height=16&seq=br006&orientation=landscape"
                    alt="Português"
                    className="w-6 h-4 object-cover rounded-sm"
                  />
                </button>
                <button
                  onClick={() => setLanguage('en')}
                  className={`w-8 h-6 flex items-center justify-center hover:opacity-80 transition-opacity cursor-pointer rounded-sm ${
                    language === 'en' ? 'ring-2 ring-amber-400' : 'opacity-60'
                  }`}
                  title="English"
                >
                  <img
                    src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/248df571686c0c8746cad1fda1508cf8.jpeg"
                    alt="English"
                    className="w-6 h-4 object-cover rounded-sm"
                  />
                </button>
              </div>
              <button
                className="w-6 h-6 flex items-center justify-center"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
          {isMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t border-zinc-700">
              <div className="flex flex-col space-y-3 pt-4">
                <a href="#home" className="hover:text-amber-400 transition-colors cursor-pointer">
                  {language === 'pt' ? 'Início' : 'Home'}
                </a>
                <a href="#about" className="hover:text-amber-400 transition-colors cursor-pointer">
                  {language === 'pt' ? 'Sobre' : 'About'}
                </a>
                <a href="#menu" className="hover:text-amber-400 transition-colors cursor-pointer">
                  Menu
                </a>
                <a href="#events" className="hover:text-amber-400 transition-colors cursor-pointer">
                  {language === 'pt' ? 'Eventos' : 'Events'}
                </a>
                <a href="#contact" className="hover:text-amber-400 transition-colors cursor-pointer">
                  {language === 'pt' ? 'Contato' : 'Contact'}
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section
        id="home"
        className="relative h-screen flex items-center justify-center overflow-hidden"
      >
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source
            src="https://public.readdy.ai/ai/video_res/9294cd06-b942-4c65-ba58-92b72eb23349.mp4"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/85 to-black/100"></div>
        <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
          <h1
            className="text-6xl md:text-8xl font-black mb-6 tracking-wider"
            style={{ fontFamily: "Exo 2, sans-serif" }}
          >
            VuVu
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-zinc-200">
            {language === 'pt'
              ? 'Um conceito totalmente inovador de bar-lounge no Rio de Janeiro'
              : 'A completely innovative bar-lounge concept in Rio de Janeiro'}
          </p>
          <p className="text-lg mb-12 text-zinc-300 max-w-2xl mx-auto">
            {language === 'pt'
              ? 'Localizado em Botafogo, oferecemos uma experiência diferenciada com fusão culinária japonesa-peruana, drinks especiais de gin e shows únicos'
              : 'Located in Botafogo, we offer a unique experience with Japanese-Peruvian culinary fusion, special gin drinks and unique shows'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://drive.google.com/file/d/1wEQQE_K9SCTaYaDz6qpZEBw_AAe4WiBt/view"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-amber-500 hover:bg-amber-600 text-black px-8 py-4 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              {language === 'pt' ? 'Ver Cardápio Completo' : 'View Full Menu'}
            </a>
            <a
              href="https://www.getinapp.com.br/rio-de-janeiro/vuvurio"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white hover:bg-white hover:text-black px-8 py-4 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              {language === 'pt' ? 'Fazer Reserva' : 'Make Reservation'}
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-zinc-800">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
              {language === 'pt' ? 'O Conceito' : 'The Concept'}
            </h2>

            <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
              <div>
                <h3 className="text-2xl font-bold mb-6 text-amber-400">
                  {language === 'pt' ? 'A Experiência VuVu' : 'The VuVu Experience'}
                </h3>
                <p className="text-lg text-zinc-300 mb-6">
                  {language === 'pt'
                    ? 'O VuVu é mais que um bar - é uma jornada sensorial única. Nossa fachada discreta esconde um universo de 160m² com 5m de pé direito, onde cada detalhe foi pensado para surpreender.'
                    : "VuVu is more than a bar - it's a unique sensory journey. Our discreet facade hides a 160m² universe with 5m high ceilings, where every detail has been designed to surprise."}
                </p>
                <p className="text-lg text-zinc-300 mb-6">
                  {language === 'pt'
                    ? 'Ao entrar, você é recebido pela Welcome Area com obras de artistas parceiros. A Dining Area convida para uma experiência gastronômica única, enquanto nossa clarabóia abraça o bar central.'
                    : 'Upon entering, you are welcomed by the Welcome Area featuring works by partner artists. The Dining Area invites you to a unique gastronomic experience, while our skylight embraces the central bar.'}
                </p>
                <p className="text-lg text-zinc-300">
                  {language === 'pt'
                    ? 'A pista de dança sob 52 lâmpadas vintage flutuantes e as fitas LED RGB customizáveis transformam cada noite em um espetáculo visual único.'
                    : 'The dance floor under 52 floating vintage lamps and customizable RGB LED strips transform each night into a unique visual spectacle.'}
                </p>
              </div>
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/00108ee5cb3e9e82b57bf90c3b6ff636.jpeg"
                  alt={language === 'pt' ? 'Interior do VuVu' : 'VuVu Interior'}
                  className="rounded-lg shadow-2xl object-cover w-full h-80"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6 bg-zinc-900 rounded-lg relative overflow-hidden">
                <div
                  className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
                  style={{
                    backgroundImage:
                      "url('https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/38b56fc94a52f12a545c71810aae2904.jpeg')",
                  }}
                ></div>
                <div className="relative z-10">
                  <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-restaurant-line text-2xl text-black"></i>
                  </div>
                  <h4 className="text-xl font-bold mb-3">
                    {language === 'pt' ? 'Fusão Culinária' : 'Culinary Fusion'}
                  </h4>
                  <p className="text-zinc-400">
                    {language === 'pt'
                      ? 'Combinação única da culinária japonesa e peruana com toques contemporâneos de boteco'
                      : 'Unique combination of Japanese and Peruvian cuisine with contemporary bar touches'}
                  </p>
                </div>
              </div>

              <div className="text-center p-6 bg-zinc-900 rounded-lg relative overflow-hidden">
                <div
                  className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
                  style={{
                    backgroundImage:
                      "url('https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/7aadf1b93d41e157c1d8ceea5f9cb95a.jpeg')",
                  }}
                ></div>
                <div className="relative z-10">
                  <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-goblet-line text-2xl text-black"></i>
                  </div>
                  <h4 className="text-xl font-bold mb-3">
                    {language === 'pt' ? 'Especialistas em Gin' : 'Gin Specialists'}
                  </h4>
                  <p className="text-zinc-400">
                    {language === 'pt'
                      ? 'Carta especial de gins e drinks autorais criados pelos nossos bartenders'
                      : 'Special gin menu and signature drinks created by our bartenders'}
                  </p>
                </div>
              </div>

              <div className="text-center p-6 bg-zinc-900 rounded-lg relative overflow-hidden">
                <div
                  className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
                  style={{
                    backgroundImage:
                      "url('https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/1ab8a3e1c23b7994ba7a25d235f9b22d.jpeg')",
                  }}
                ></div>
                <div className="relative z-10">
                  <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-music-line text-2xl text-black"></i>
                  </div>
                  <h4 className="text-xl font-bold mb-3">
                    {language === 'pt' ? 'Shows & Eventos' : 'Shows & Events'}
                  </h4>
                  <p className="text-zinc-400">
                    {language === 'pt'
                      ? 'Palco para apresentações musicais e eventos especiais em ambiente único'
                      : 'Stage for musical performances and special events in a unique environment'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Menu Section */}
      <section id="menu" className="py-20 bg-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row items-center justify-between mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 md:mb-0">
                Menu
              </h2>
              <a
                href="https://drive.google.com/file/d/1wEQQE_K9SCTaYaDz6qpZEBw_AAe4WiBt/view"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-amber-500 hover:bg-amber-600 text-black px-6 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap flex items-center"
              >
                <i className="ri-file-text-line mr-2"></i>
                Ver Cardápio Completo
              </a>
            </div>

            <div className="grid md:grid-cols-2 gap-12">
              {/* Drinks */}
              <div>
                <h3 className="text-3xl font-bold mb-8 text-amber-400 text-center">
                  Drinks &amp; Gins
                </h3>
                <div className="space-y-6">
                  <div className="flex justify-between items-start border-b border-zinc-700 pb-4">
                    <div>
                      <h4 className="text-xl font-semibold">
                        God save the gin
                      </h4>
                      <p className="text-zinc-400">
                        Gin, xarope de capim limão e espumante
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$37</span>
                  </div>

                  <div className="flex justify-between items-start border-b border-zinc-700 pb-4">
                    <div>
                      <h4 className="text-xl font-semibold">Cordial</h4>
                      <p className="text-zinc-400">
                        Bourbon, cordial maracujá com manga, angostura e limão
                        siciliano
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$37</span>
                  </div>

                  <div className="flex justify-between items-start border-b border-zinc-700 pb-4">
                    <div>
                      <h4 className="text-xl font-semibold">11:11</h4>
                      <p className="text-zinc-400">
                        Cachaça, abacaxi, xarope de coco e soda de gengibre
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$37</span>
                  </div>

                  <div className="flex justify-between items-center border-b border-zinc-700 pb-4">
                    <div>
                      <h4 className="text-xl font-semibold">Doutora</h4>
                      <p className="text-zinc-400">
                        Gin, mix de morango com gengibre, limão e espuma de
                        framboesa com baunilha
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$37</span>
                  </div>

                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="text-xl font-semibold">G&amp;T e CAIPS</h4>
                      <p className="text-zinc-400">
                        Gin &amp; Tônica e Caipirinhas variadas
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$28</span>
                  </div>
                </div>
              </div>

              {/* Food */}
              <div>
                <h3 className="text-3xl font-bold mb-8 text-amber-400 text-center">
                  Fusão Nikkei
                </h3>
                <div className="space-y-6">
                  <div className="flex justify-between items-start border-b border-zinc-700 pb-4">
                    <div>
                      <h4 className="text-xl font-semibold">
                        Tartarde Salmão
                      </h4>
                      <p className="text-zinc-400">
                        Salmão, cebola roxa, molho de ostras, mostarda artesanal
                        e alho poró crispy
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$49</span>
                  </div>

                  <div className="flex justify-between items-start border-b border-zinc-700 pb-4">
                    <div>
                      <h4 className="text-xl font-semibold">
                        Degustação de ceviche
                      </h4>
                      <p className="text-zinc-400">
                        Três taças com uma porção de cada ceviche, Salmão, atum
                        e peixe branco com camarão
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$79</span>
                  </div>

                  <div className="flex justify-between items-start border-b border-zinc-700 pb-4">
                    <div>
                      <h4 className="text-xl font-semibold">
                        Combinado 20 peças
                      </h4>
                      <p className="text-zinc-400">
                        6 sashimis, 8 shushis, 6 rolls
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$97</span>
                  </div>

                  <div className="flex justify-between items-start border-b border-zinc-700 pb-4">
                    <div>
                      <h4 className="text-xl font-semibold">
                        Poke de salmão
                      </h4>
                      <p className="text-zinc-400">
                        Salmão, arroz, sunomono, manga, cebola roxa, cream cheese
                        e alho poró
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$49</span>
                  </div>

                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="text-xl font-semibold">
                        Roll Double sake
                      </h4>
                      <p className="text-zinc-400">
                        Tartar de salmão e avocade com cobertura de salmão
                        maçaricado e molho oriental
                      </p>
                    </div>
                    <span className="text-amber-400 font-bold">R$59</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Events Section */}
      <section id="events" className="py-20 bg-zinc-800">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
              {language === 'pt' ? 'Palco' : 'Stage'}
            </h2>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-zinc-900 rounded-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/7736e5815b4bb61171dd15ec7485d8da.jpeg"
                  alt={language === 'pt' ? 'Show no VuVu' : 'Live Show at VuVu'}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">
                    {language === 'pt' ? 'Shows Ao Vivo' : 'Live Shows'}
                  </h3>
                  <p className="text-zinc-400 mb-4">
                    {language === 'pt'
                      ? 'Artistas locais e nacionais se apresentam em nosso palco íntimo durante a semana'
                      : 'Local and national artists perform on our intimate stage during the week'}
                  </p>
                  <div className="flex items-center text-amber-400">
                    <i className="ri-calendar-line mr-2"></i>
                    <span>
                      {language === 'pt'
                        ? 'Dom, Ter, Qua & Qui - 19h'
                        : 'Sun, Tue, Wed & Thu - 7pm'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-zinc-900 rounded-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/01c352727077b17b5a689e07963dde26.jpeg"
                  alt={language === 'pt' ? 'DJ Set no VuVu' : 'DJ Set at VuVu'}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">DJ Sets</h3>
                  <p className="text-zinc-400 mb-4">
                    {language === 'pt'
                      ? 'DJs residentes e convidados comandam a pista com house, techno e música brasileira'
                      : 'Resident and guest DJs command the dance floor with house, techno and Brazilian music'}
                  </p>
                  <div className="flex items-center text-amber-400">
                    <i className="ri-calendar-line mr-2"></i>
                    <span>
                      {language === 'pt' ? 'Sex & Sáb - 21h' : 'Fri & Sat - 9pm'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <h3 className="text-2xl font-bold mb-6">
                {language === 'pt' ? 'Agenda' : 'Schedule'}
              </h3>
              <div className="grid md:grid-cols-3 gap-6">
                <a
                  href="https://www.instagram.com/vuvu.rio/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-zinc-900 p-6 rounded-lg hover:bg-zinc-800 transition-colors cursor-pointer block relative overflow-hidden"
                >
                  <div
                    className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
                    style={{
                      backgroundImage:
                        "url('https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/b5d7ce19acf7f3ad722a5cbbf5a84900.png')",
                    }}
                  ></div>
                  <div className="relative z-10">
                    <div className="text-amber-400 font-bold text-lg mb-2">
                      {language === 'pt' ? 'SEX & SÁB' : 'FRI & SAT'}
                    </div>
                    <h4 className="font-bold mb-2">DJ Set Open Format</h4>
                    <p className="text-zinc-400 text-sm">
                      {language === 'pt'
                        ? 'Todas as sextas e sábados'
                        : 'Every Friday and Saturday'}
                    </p>
                  </div>
                </a>

                <a
                  href="https://www.sympla.com.br/evento/perversao-acustica/3203395?_gl=1*1m7t3bv*_gcl_au*MTU5NjA0MDY0MS4xNzYyMjgxNzI1LjE0ODcyMTUwOTYuMTc2MjI4MTc2NS*_ga*MTM5MDc3MTk5Ny4xNzYyMjgxNzI2*_ga_KXH10SQTZF*czE3NjIyODE3MjUkbzEkZzEkdDE3NjIyODE3ODUkajYwJGwwJGg4NzEwNDQwNDk.&referrer=l.instagram.com&referrer=l.instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-zinc-900 p-6 rounded-lg hover:bg-zinc-800 transition-colors cursor-pointer block relative overflow-hidden"
                >
                  <div
                    className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
                    style={{
                      backgroundImage:
                        "url('https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/2d59384bd6001b2d7dc37b5e48fc8a2d.png')",
                    }}
                  ></div>
                  <div className="relative z-10">
                    <div className="text-amber-400 font-bold text-lg mb-2">
                      10 DEZ
                    </div>
                    <h4 className="font-bold mb-2">Cabana da Malandra</h4>
                  </div>
                </a>

                <a
                  href="https://www.instagram.com/vuvu.rio/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-zinc-900 p-6 rounded-lg hover:bg-zinc-800 transition-colors cursor-pointer block relative overflow-hidden"
                >
                  <div
                    className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
                    style={{
                      backgroundImage:
                        "url('https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/de06de9049080db12b6870d70c26383a.png')",
                    }}
                  ></div>
                  <div className="relative z-10">
                    <div className="text-amber-400 font-bold text-lg mb-2">
                      {language === 'pt' ? 'TODA QUINTA' : 'EVERY THURSDAY'}
                    </div>
                    <h4 className="font-bold mb-2">Vozes do VuVu</h4>
                    <p className="text-zinc-400 text-sm">
                      {language === 'pt'
                        ? 'Premiação em dinheiro'
                        : 'Cash prizes'}
                    </p>
                  </div>
                </a>

                <a
                  href="https://www.instagram.com/forrodovuvu/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-zinc-900 p-6 rounded-lg hover:bg-zinc-800 transition-colors cursor-pointer block relative overflow-hidden"
                >
                  <div
                    className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
                    style={{
                      backgroundImage:
                        "url('https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/3bfc62557251d7ca2351da0f5d1208f2.png')",
                    }}
                  ></div>
                  <div className="relative z-10">
                    <div className="text-amber-400 font-bold text-lg mb-2">
                      {language === 'pt' ? 'TODA TERÇA' : 'EVERY TUESDAY'}
                    </div>
                    <h4 className="font-bold mb-2">Forró do VuVu</h4>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Corporate Events Section */}
      <section className="py-20 bg-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
              {language === 'pt' ? 'Eventos Corporativos' : 'Corporate Events'}
            </h2>

            <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
              <div>
                <h3 className="text-2xl font-bold mb-6 text-amber-400">
                  {language === 'pt' ? 'Espaço Exclusivo para Sua Empresa' : 'Exclusive Space for Your Company'}
                </h3>
                <p className="text-lg text-zinc-300 mb-6">
                  {language === 'pt'
                    ? 'O VuVu oferece um ambiente sofisticado e versátil para eventos corporativos, feiras, exposições e celebrações empresariais. Nosso espaço de 160m² pode ser totalmente personalizado para atender às necessidades do seu evento.'
                    : 'VuVu offers a sophisticated and versatile environment for corporate events, fairs, exhibitions and business celebrations. Our 160m² space can be fully customized to meet your event needs.'}
                </p>

                <div className="space-y-4 mb-8">
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-building-line text-amber-400"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">
                        {language === 'pt' ? 'Eventos Corporativos' : 'Corporate Events'}
                      </h4>
                      <p className="text-zinc-400 text-sm">
                        {language === 'pt'
                          ? 'Confraternizações, lançamentos de produtos, reuniões executivas'
                          : 'Company parties, product launches, executive meetings'}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-presentation-line text-amber-400"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">
                        {language === 'pt' ? 'Feiras & Exposições' : 'Fairs & Exhibitions'}
                      </h4>
                      <p className="text-zinc-400 text-sm">
                        {language === 'pt'
                          ? 'Espaço flexível para showcases e apresentações comerciais'
                          : 'Flexible space for showcases and commercial presentations'}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-calendar-event-line text-amber-400"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">
                        {language === 'pt' ? 'Eventos Especiais' : 'Special Events'}
                      </h4>
                      <p className="text-zinc-400 text-sm">
                        {language === 'pt'
                          ? 'Celebrações, networking, workshops e treinamentos'
                          : 'Celebrations, networking, workshops and training'}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-restaurant-line text-amber-400"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">
                        {language === 'pt' ? 'Catering Personalizado' : 'Customized Catering'}
                      </h4>
                      <p className="text-zinc-400 text-sm">
                        {language === 'pt'
                          ? 'Menu executivo e drinks especiais para seu evento'
                          : 'Executive menu and special drinks for your event'}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-zinc-800 p-6 rounded-lg">
                  <h4 className="font-bold mb-3 text-amber-400">
                    {language === 'pt' ? 'Entre em Contato' : 'Get in Touch'}
                  </h4>
                  <p className="text-zinc-300 mb-4">
                    {language === 'pt'
                      ? 'Solicite um orçamento personalizado para seu evento corporativo. Nossa equipe está pronta para criar uma experiência única para sua empresa.'
                      : 'Request a personalized quote for your corporate event. Our team is ready to create a unique experience for your company.'}
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <a
                      href="tel:+5521965580796"
                      className="bg-amber-500 hover:bg-amber-600 text-black px-6 py-3 rounded-full font-semibold cursor-pointer whitespace-nowrap text-center"
                    >
                      <i className="ri-phone-line mr-2"></i>
                      {language === 'pt' ? 'Ligar Agora' : 'Call Now'}
                    </a>
                    <a
                      href="https://wa.me/5521965580796?text=Olá! Gostaria de solicitar um orçamento para evento corporativo no VuVu."
                      target="_blank"
                      rel="noopener noreferrer"
                      className="border-2 border-amber-500 text-amber-500 hover:bg-amber-600 hover:text-black px-6 py-3 rounded-full font-semibold cursor-pointer whitespace-nowrap text-center"
                    >
                      <i className="ri-whatsapp-line mr-2"></i>WhatsApp
                    </a>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <div className="relative">
                  <img
                    src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/7488beefb89ed6addc21ddaf4f0ff3ad.png"
                    alt={language === 'pt' ? 'Eventos Corporativos no VuVu' : 'Corporate Events at VuVu'}
                    className="rounded-lg shadow-2xl object-cover w-full h-64"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-lg"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <h4 className="text-lg font-bold text-white mb-1">
                      {language === 'pt' ? 'Ambiente Profissional' : 'Professional Environment'}
                    </h4>
                    <p className="text-zinc-200 text-sm">
                      {language === 'pt'
                        ? 'Tecnologia de ponta e acústica perfeita'
                        : 'Cutting-edge technology and perfect acoustics'}
                    </p>
                  </div>
                </div>

                <div className="relative">
                  <img
                    src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/123760363571d21ae82d6497c5b05a0c.png"
                    alt={language === 'pt' ? 'Espaço para Feiras e Exposições' : 'Space for Fairs and Exhibitions'}
                    className="rounded-lg shadow-2xl object-cover w-full h-64"
                  />
                </div>

                <div className="relative">
                  <img
                    src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/8d84cbf69fb80acf377159f05ee86cab.png"
                    alt={language === 'pt' ? 'Networking e Eventos Especiais' : 'Networking and Special Events'}
                    className="rounded-lg shadow-2xl object-cover w-full h-64"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <h4 className="text-lg font-bold text-white mb-1">
                      {language === 'pt' ? 'Networking e Eventos Especiais' : 'Networking and Special Events'}
                    </h4>
                    <p className="text-zinc-200 text-sm">
                      {language === 'pt'
                        ? 'Ambiente propício para conexões e eventos exclusivos'
                        : 'Environment conducive to connections and exclusive events'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
              {language === 'pt' ? 'Contato & Localização' : 'Contact & Location'}
            </h2>

            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h3 className="text-2xl font-bold mb-6 text-amber-400">
                  {language === 'pt' ? 'Informações' : 'Information'}
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-map-pin-line text-amber-400"></i>
                    </div>
                    <div>
                      <p className="font-semibold">
                        {language === 'pt' ? 'Endereço' : 'Address'}
                      </p>
                      <p className="text-zinc-400">
                        Rua Sorocaba, 601 - Botafogo<br />
                        Rio de Janeiro - RJ
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-time-line text-amber-400"></i>
                    </div>
                    <div>
                      <p className="font-semibold">
                        {language === 'pt' ? 'Horário de Funcionamento' : 'Opening Hours'}
                      </p>
                      <p className="text-zinc-400">
                        {language === 'pt'
                          ? 'Ter a Dom: 18h às 2h\nSegunda: Fechado'
                          : 'Tue to Sun: 6pm to 2am\nMonday: Closed'}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-5 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-phone-line text-amber-400"></i>
                    </div>
                    <div>
                      <p className="font-semibold">
                        {language === 'pt' ? 'Telefone' : 'Phone'}
                      </p>
                      <p className="text-zinc-400">(21) 96558-0796</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-instagram-line text-amber-400"></i>
                    </div>
                    <div>
                      <p className="font-semibold">Instagram</p>
                      <p className="text-zinc-400">@vuvu.botafogo</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                      <i className="ri-links-line text-amber-400"></i>
                    </div>
                    <div>
                      <p className="font-semibold">Links</p>
                      <a
                        href="https://linklist.bio/vuvurio"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-zinc-400 hover:text-amber-400 transition-colors"
                      >
                        linklist.bio/vuvurio
                      </a>
                    </div>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="flex flex-col sm:flex-row gap-4">
                    <a
                      href="https://www.getinapp.com.br/rio-de-janeiro/vuvurio"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-amber-500 hover:bg-amber-600 text-black px-6 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap text-center"
                    >
                      {language === 'pt' ? 'Reservar Mesa' : 'Reserve Table'}
                    </a>
                    <a
                      href="https://drive.google.com/file/d/1wEQQE_K9SCTaYaDz6qpZEBw_AAe4WiBt/view"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="border-2 border-amber-500 text-amber-500 hover:bg-amber-600 hover:text-black px-6 py-4 rounded-full font-semibold cursor-pointer whitespace-nowrap text-center"
                    >
                      {language === 'pt' ? 'Cardápio Completo' : 'Full Menu'}
                    </a>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-6 text-amber-400">
                  {language === 'pt' ? 'Localização' : 'Location'}
                </h3>
                <div className="bg-zinc-800 rounded-lg overflow-hidden">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3675.2234567890123!2d-43.1828!3d-22.9533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x997f5a0a0a0a0a0a%3A0x0a0a0a0a0a0a0a0a!2sRua%20Sorocaba%2C%20601%20-%20Botafogo%2C%20Rio%20de%20Janeiro%20-%20RJ!5e0!3m2!1spt-BR!2sbr!4v1234567890123"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title={language === 'pt' ? 'Localização do VuVu' : 'VuVu Location'}
                  ></iframe>
                </div>

                <div className="mt-6 p-6 bg-zinc-800">
                  <h4 className="font-bold mb-3">
                    {language === 'pt' ? 'Como Chegar' : 'How to Get There'}
                  </h4>
                  <div className="space-y-2 text-zinc-400">
                    <p>
                      <strong>{language === 'pt' ? 'Metrô:' : 'Metro:'}</strong> {language === 'pt' ? 'Estação Botafogo (Linha 1)' : 'Botafogo Station (Line 1)'}
                    </p>
                    <p>
                      <strong>{language === 'pt' ? 'Ônibus:' : 'Bus:'}</strong> {language === 'pt' ? 'Várias linhas passam pela Praia de Botafogo' : 'Several lines pass through Praia de Botafogo'}
                    </p>
                    <p>
                      <strong>Uber/Taxi:</strong> {language === 'pt' ? 'Referência: Rua Sorocaba, 601 - Botafogo' : 'Reference: Rua Sorocaba, 601 - Botafogo'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-12">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-3 gap-8">
              <div>
                <div className="flex items-center mb-4">
                  <img
                    src="https://static.readdy.ai/image/8fef3d18c1dff7c3ed5882347a08ec97/ad26e583bb7abfbcce906204b32e3a51.png"
                    alt="VuVu Logo"
                    className="w-12 h-12 mr-3 filter brightness-0 invert"
                  />
                  <h3
                    className="text-2xl font-bold tracking-wider"
                    style={{ fontFamily: "Exo 2, sans-serif" }}
                  >
                    VuVu
                  </h3>
                </div>
                <p className="text-zinc-400 mb-4">
                  {language === 'pt'
                    ? 'Um conceito totalmente inovador de bar-lounge no coração de Botafogo, onde cada experiência é única e inesquecível.'
                    : 'A completely innovative bar-lounge concept in the heart of Botafogo, where every experience is unique and unforgettable.'}
                </p>
                <div className="flex space-x-4">
                  <a
                    href="https://linklist.bio/vuvurio"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-instagram-line text-black"></i>
                  </a>
                  <a
                    href="https://www.getinapp.com.br/rio-de-janeiro/vuvurio"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-calendar-line text-black"></i>
                  </a>
                  <a
                    href="tel:+5521965580796"
                    className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-black"></i>
                  </a>
                </div>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">
                  {language === 'pt' ? 'Links Rápidos' : 'Quick Links'}
                </h4>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="#about"
                      className="text-zinc-400 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      {language === 'pt' ? 'Sobre o VuVu' : 'About VuVu'}
                    </a>
                  </li>
                  <li>
                    <a
                      href="#menu"
                      className="text-zinc-400 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      Menu
                    </a>
                  </li>
                  <li>
                    <a
                      href="#events"
                      className="text-zinc-400 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      {language === 'pt' ? 'Eventos' : 'Events'}
                    </a>
                  </li>
                  <li>
                    <a
                      href="#contact"
                      className="text-zinc-400 hover:text-amber-400 transition-colors cursor-pointer"
                    >
                      {language === 'pt' ? 'Contato' : 'Contact'}
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">
                  {language === 'pt' ? 'Contato' : 'Contact'}
                </h4>
                <ul className="space-y-2 text-zinc-400">
                  <li>Rua Sorocaba, 601 - Botafogo</li>
                  <li>Rio de Janeiro - RJ</li>
                  <li>(21) 96558-0966</li>
                  <li>@vuvu.botafogo</li>
                  <li>
                    <a
                      href="https://linklist.bio/vuvurio"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-amber-400 transition-colors"
                    >
                      linklist.bio/vuvurio
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="border-t border-zinc-800 mt-8 pt-8 text-center text-zinc-400">
              <p>
                {language === 'pt'
                  ? '© 2021 VuVu Bar Lounge. Todos os direitos reservados. | '
                  : '© 2021 VuVu Bar Lounge. All rights reserved. | '}
                <a
                  href="https://readdy.ai/?origin=logo"
                  className="hover:text-amber-400 transition-colors"
                >
                  Website Builder
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
